import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { CloudFileListingContext } from "../../../CloudFileListingContext";
import { RequestMultipleCloudFilesWaitingForClientResponseDialog } from "./RequestMultipleCloudFilesWaitingForClientResponseDialog";

export const RequestMultipleCloudFilesWaitingForClientResponseButton = (): JSX.Element => {
    const { selectedItems } = useContext(CloudFileListingContext);

    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                text="Request Waiting for Client Response"
                icon="HourGlass"
                disabled={!selectedItems.length}
                onClick={onOpen}
            />
            {isOpen && (
                <RequestMultipleCloudFilesWaitingForClientResponseDialog key={String(isOpen)} onClose={onClose} />
            )}
        </AuthorizationWrapper>
    );
};
